export default "__VITE_ASSET__DJSWTw1E__"